import Container from 'mango-ui/layout/Container';
import * as React from 'react';

export interface IFileUploaderProps {
  onFileSelected?: IFunction;
  label?: string;
  accept?: '*/*';
}

export default ({ onFileSelected, label, accept }: IFileUploaderProps) => {
  return (
    <div style={{ margin: '10px 0' }}>
      <label
        style={{ border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '5px', padding: '5px' }}
      >
        {label}
        <input type="file" hidden accept={accept} multiple onChange={onFileSelected}/>
      </label>
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/FileUploaderView.tsx